import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../components/Auth/ProtectedRoute';

// Lazy load pages
const Home = lazy(() => import('../pages/Home/Home'));
const About = lazy(() => import('../pages/About'));
const Products = lazy(() => import('../pages/Products/Products'));
const ProductDetail = lazy(() => import('../pages/ProductDetail/ProductDetail'));
const Cart = lazy(() => import('../pages/Cart'));
const Login = lazy(() => import('../pages/Login'));
const Register = lazy(() => import('../pages/Register'));
const Contact = lazy(() => import('../pages/Contact'));
const Order = lazy(() => import('../pages/Order/Order'));
const OrderDetail = lazy(() => import('../pages/OrderDetail'));
const PaymentResult = lazy(() => import('../pages/PaymentResult'));
const InvoiceManager = lazy(() => import('../pages/InvoiceManager'));
const Profile = lazy(() => import('../pages/Profile'));
const MyOrders = lazy(() => import('../pages/MyOrders'));
const ApiTest = lazy(() => import('../components/Dev/ApiTest'));
const AuthSuccess = lazy(() => import('../pages/AuthSuccess'));

// Admin components
const AdminLayout = lazy(() => import('../admin/components/AdminLayout'));
const AdminDashboard = lazy(() => import('../admin/pages/Dashboard/AdminDashboard'));
const ProductManagement = lazy(() => import('../admin/pages/Products/ProductManagement'));
const CategoryManager = lazy(() => import('../admin/pages/Categories/CategoryManager'));
const OrderManagement = lazy(() => import('../admin/pages/Orders/OrderManagement'));
const UserManagement = lazy(() => import('../admin/pages/Users/UserManagement'));

// Reports components
const ReportsLayout = lazy(() => import('../admin/pages/Reports/ReportsLayout'));
const ReportsOverview = lazy(() => import('../admin/pages/Reports/ReportsOverview'));
const RevenueReport = lazy(() => import('../admin/pages/Reports/RevenueReport'));
const OrdersReport = lazy(() => import('../admin/pages/Reports/OrdersReport'));
const ProductsReport = lazy(() => import('../admin/pages/Reports/ProductsReport'));
const CustomersReport = lazy(() => import('../admin/pages/Reports/CustomersReport'));
const WarehouseManagement = lazy(() => import('../admin/pages/Warehouse/WarehouseManagement'));
const WarehouseInventoryDashboard = lazy(() => import('../admin/pages/Warehouse/WarehouseInventoryDashboard'));
const StorageManagement = lazy(() => import('../admin/pages/Storage/StorageManagement'));

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/products" element={<Products />} />
      <Route path="/products/:id" element={<ProductDetail />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/order" element={<Order />} />
      <Route path="/orders/:id" element={
        <ProtectedRoute requireAuth={true}>
          <OrderDetail />
        </ProtectedRoute>
      } />
      <Route path="/thanh-toan/ket-qua" element={<PaymentResult />} />
      <Route path="/profile" element={
        <ProtectedRoute requireAuth={true}>
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/orders" element={
        <ProtectedRoute requireAuth={true}>
          <MyOrders />
        </ProtectedRoute>
      } />
      <Route path="/api-test" element={<ApiTest />} />
      <Route path="/auth/success" element={<AuthSuccess />} />

      {/* Admin nested routes */}
      <Route path="/admin" element={
        <ProtectedRoute requireAuth={true} requireAdmin={true}>
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route index element={<AdminDashboard />} />

        {/* Products routes */}
        <Route path="products" element={<ProductManagement />} />
        <Route path="products/new" element={<ProductManagement />} />
        <Route path="products/:id/edit" element={<ProductManagement />} />

        {/* Categories routes */}
        <Route path="categories" element={<CategoryManager />} />

        {/* Orders routes */}
        <Route path="orders" element={<OrderManagement />} />
        <Route path="orders/:id" element={<OrderManagement />} />

        {/* Users routes */}
        <Route path="users" element={<UserManagement />} />
        <Route path="users/new" element={<UserManagement />} />
        <Route path="users/:id" element={<UserManagement />} />
        <Route path="users/:id/edit" element={<UserManagement />} />

        {/* Warehouse routes */}
        <Route path="warehouse" element={<WarehouseManagement />} />
        <Route path="warehouse/:section" element={<WarehouseManagement />} />
        <Route path="warehouse-dashboard" element={<WarehouseInventoryDashboard />} />

        {/* Storage routes */}
        <Route path="storage" element={<StorageManagement />} />

        {/* Reports nested routes */}
        <Route path="reports" element={<ReportsLayout />}>
          <Route index element={<ReportsOverview />} />
          <Route path="revenue" element={<RevenueReport />} />
          <Route path="orders" element={<OrdersReport />} />
          <Route path="products" element={<ProductsReport />} />
          <Route path="customers" element={<CustomersReport />} />
        </Route>

        <Route path="settings" element={
          <div className="card">
            <h2 className="text-xl font-semibold mb-4">Cài đặt</h2>
            <p className="text-gray-600">
              Phần này đang được phát triển. Giao diện quản lý cài đặt sẽ được triển khai tại đây.
            </p>
          </div>
        } />
      </Route>

      <Route path="*" element={
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
            <p className="text-xl text-gray-600 mb-8">Không tìm thấy trang</p>
            <a href="/" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
              Về trang chủ
            </a>
          </div>
        </div>
      } />
    </Routes>
  );
};

export default AppRoutes;
